import { GlobalIcon, Typography } from "get-life-storybook-ts";

interface PriceTransparencyNoteProps {
  translate: (key: string) => string;
}

const PriceTransparencyNote = ({ translate }: PriceTransparencyNoteProps) => {
  return (
    <div className="mt-3 px-3 py-2 bg-blue-gray-50 rounded-md flex flex-col gap-1">
      <div className="flex items-start gap-2">
        <GlobalIcon iconName="TicketIcon" size="XS" color="#424242" />
        <Typography
          variant="BodyXSmall"
          weight="500"
          text={translate("compliance.upsell.it.price.taxesIncluded")}
          className="text-blue-gray-800"
        />
      </div>
      <div className="flex items-start gap-2">
        <GlobalIcon iconName="FilledCheckIcon" size="XS" color="#018565" />
        <Typography
          variant="BodyXSmall"
          weight="400"
          text={translate("compliance.upsell.it.price.noExtraFees")}
          className="text-blue-gray-700"
        />
      </div>
    </div>
  );
};

export default PriceTransparencyNote;
